import PromptModal from 'components/common/Modals/PromptModal';
import { Typography } from '@mui/material';
import { remCalc } from '@monorepo/shared/src/util/style-util';
import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util';
import makeStyles from '@mui/styles/makeStyles';

const t = (key, options?) => translate('activities', key, { ...options });

type Props = {
  onAccept: () => void;
  onReject: () => void;
};

const HavePrinterModal = ({ onAccept, onReject }: Props) => {
  const { textClass } = useStyles();
  return (
    <PromptModal onAccept={onAccept} onReject={onReject}>
      <Typography variant="h2" className={textClass}>
        {t('havePrinter')}
      </Typography>
    </PromptModal>
  );
};

export default HavePrinterModal;

const useStyles = makeStyles((theme) => ({
  textClass: {
    padding: `0 ${remCalc(40)} ${remCalc(20)} ${remCalc(40)}`,
    textAlign: 'center',
    [theme.breakpoints.down('md')]: {
      padding: remCalc(16),
      fontSize: '5vmin',
    },
    [theme.breakpoints.down('md')]: {
      padding: 0,
      fontSize: '5vmin',
    },
  },
}));
